(function () {
    var elements = {
        triggers: document.querySelectorAll('[data-toggle-edit-for]'),
        displayFields: document.querySelectorAll('[data-toggle-edit-display]'),
        editFields: document.querySelectorAll('[data-toggle-edit-field]')
    };

    var events = function () {
        Array.prototype.forEach.call(elements.triggers, function (el) {
            el.onclick = toggleEditField;
        });
    };

    var toggleEditField = function (e) {
        e.preventDefault();

        //resetDisplays();
        //resetFields();

        var targetName = e.target.getAttribute('data-toggle-edit-for');
        var displayField = document.querySelector('[data-toggle-edit-display=' + targetName + ']');
        var editField = document.querySelector('[data-toggle-edit-field=' + targetName + ']');

        if (displayField.classList.contains('hidden')) {
            editField.className += ' hidden';
            displayField.className = displayField.className.replace(' hidden', '');

        } else {
            displayField.className += ' hidden';
            editField.className = editField.className.replace(' hidden', '');
        }
        delivery.FlickityResize();
    };

    var resetDisplays = function () {
        Array.prototype.forEach.call(elements.displayFields, function (el) {
            if (el.className.indexOf(' hidden')) {
                el.className = el.className.replace(' hidden', '');
            }
        });
        delivery.FlickityResize();
    };

    var resetFields = function () {
        Array.prototype.forEach.call(elements.editFields, function (el) {
            if (el.className.indexOf(' hidden') == -1) {
                el.className += ' hidden';
            }
        });
        delivery.FlickityResize();
    };

    var init = function () {
        events();
    };

    init();
}());
